import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Col, Modal, ModalBody, Row } from "reactstrap";
import { SignOut, Trash } from "@phosphor-icons/react";
import { Select } from "antd";
import { generateYearOptions } from "helpers/yearHelper";

const ModalFilter = ({ show, onConfirmClick, onCloseClick }) => {
	const [currentYear, setCurrentYear] = useState(null);

	const years = generateYearOptions();

	const { Option } = Select;

	return (
		<Modal size="md" isOpen={show} toggle={onCloseClick} centered={true}>
			<div className="modal-content">
				<ModalBody className="px-4 py-5 text-center">
					<p className="text-muted font-size-16 mb-4">
						Você deseja ver os planos de ação de qual ano?
					</p>

					<Row>
						<Col
							md="12"
							style={{
								display: "flex",
								justifyContent: "center",
								width: "100%",
							}}
						>
							<Select
								id="selectAno"
								value={currentYear}
								onChange={(value) => setCurrentYear(value)}
								style={{ width: "50%" }}
								placeholder="Selecione o ano"
							>
								<Option key="todos" value="todos">
									Todos
								</Option>
								{years.map((option) => (
									<Option
										key={option.value}
										value={option.value}
									>
										{option.label}
									</Option>
								))}
							</Select>
						</Col>
					</Row>

					<div className="hstack gap-2 justify-content-center mb-0 mt-3">
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={() => onConfirmClick(currentYear)}
						>
							Confirmar
						</Button>
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={onCloseClick}
						>
							<SignOut size={16} /> Fechar
						</Button>
					</div>
				</ModalBody>
			</div>
		</Modal>
	);
};

ModalFilter.propTypes = {
	onCloseClick: PropTypes.func,
	onConfirmClick: PropTypes.func,
	show: PropTypes.bool,
};

export default ModalFilter;
